import type { SortableItemUIProps } from "@tql/ui-components-react/kendo/sortable";
import { FormField } from "@tql/ui-components-react/tql/form/beta";

import type { Stop } from "~/features/ftl/shared/ftl-stop";

import * as styles from "../../create-ftl-shipment.module.css";
import { FTLShipmentStopForm } from "./ftl-shipment-stop-form/ftl-shipment-stop-form.tsx";

export function ShipmentSortableItemContainer(
	props: Readonly<SortableItemUIProps>,
) {
	const dataItem = props.dataItem as Stop;
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- props comes from Kendo
	const attributes = props.attributes;
	const forwardRef = props.forwardRef;
	const style = props.style;
	return (
		<div
			ref={forwardRef}
			style={{ ...style, cursor: "move" }}
			{...attributes}
			key={dataItem.id}
			className={styles.stop}
			data-testid={`stop-wrapper-${dataItem.id}`}
			id={`stop-${dataItem.id}`}
		>
			<FormField component={FTLShipmentStopForm} stop={dataItem} />
		</div>
	);
}
